<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        fromTypeOptions: [], // 来源类型
        cardTypeOptions: [], // 卡类型
        oilStationTypeOptions: [], // 油站类型
        form: [
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 消费时间
            label: '消费时间',
            value: 'recordTime',
            type: 'date',
            default: [],
            placeholder: '请选择消费时间',
            attr: {
              type: 'daterange',
            },
          },
          // { // 油站名称
          //   label: '油站名称',
          //   value: 'serviceName',
          //   type: 'input',
          //   placeholder: '请输入油站名称',
          // },
          // { // 单号
          //   label: '单号',
          //   value: 'orderId',
          //   type: 'input',
          //   placeholder: '请输入单号',
          // },
          // { // 油站类型
          //   label: '油站类型',
          //   value: 'oilStationType',
          //   type: 'select',
          //   default: '2',
          //   placeholder: '请选择油站类型',
          //   disabled: false,
          // },
          // { // 结算时间
          //   label: '结算时间',
          //   value: 'payTime',
          //   type: 'date',
          //   default: [],
          //   placeholder: '请选择结算时间',
          //   attr: {
          //     type: 'daterange',
          //   },
          // },
          { // 来源类型
            label: '来源类型',
            value: 'fromType',
            type: 'select',
            default: '2',
            placeholder: '请选择来源类型',
            onChange: (val) => {
              this.onChangeFromType(val);
            },
          },
          { // 卡类型
            label: '卡类型',
            value: 'cardType',
            type: 'select',
            // default: -1,
            placeholder: '请选择卡类型',
          },
          { // 服务商
            label: '服务商',
            value: 'serviceName',
            type: 'input',
            placeholder: '请输入服务商',
          },
          { // 卡号
            label: '卡号',
            value: 'cardNum',
            type: 'input',
            placeholder: '请输入卡号',
          },
          { // 是否到期
            label: '是否到期',
            value: 'expire',
            type: 'select',
            placeholder: '请选择是否到期',
            options: [
              {
                label: '未到期',
                value: 0,
              },
              {
                label: '已到期',
                value: 1,
              },
            ],
          },
          { // 消费地点
            label: '消费地点',
            value: 'address',
            type: 'input',
            placeholder: '请输入消费地点',
          },
        ],
      },
    };
  },
  methods: {
    onChangeFromType (val) {
      const fromType = val || this.$refs.searchBox.getVal('fromType') || '4';
      this.setFormAttrVal({
        form: this.searchBoxData,
        attr: 'disabled',
        value: fromType !== '4',
        names: ['oilStationType'],
      });
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.payTime && searchBoxData.payTime.length) { // 结算时间
        searchBoxData.payStartTime = this.formatDate(searchBoxData.payTime[0]);
        searchBoxData.payEndTime = this.formatDate(searchBoxData.payTime[1]);
      }
      delete searchBoxData.payTime;
      if (searchBoxData.recordTime && searchBoxData.recordTime.length) { // 消费时间
        searchBoxData.recordStartTime = this.formatDate(searchBoxData.recordTime[0]);
        searchBoxData.recordEndTime = this.formatDate(searchBoxData.recordTime[1]);
      }
      delete searchBoxData.recordTime;
      this.$refs.tableBox.saveSearchBoxData({
        cardCategory: this.$route.path.includes('oil') ? 1 : 2,
        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'RECHARGE_CONSUME_RECORD_SOURCE_TYPE,RECHARGE_CONSUME_RECORD_CARD_TYPE,OIL_STATION_TYPE,GAS_RECHARGE_CONSUME_RECORD_SOURCE_TYPE,GAS_RECHARGE_CONSUME_RECORD_CARD_TYPE',
    });
    this.searchBoxData.fromTypeOptions = this.$route.path.includes('gasCard') ? [
      ...enumsList[3],
    ] : [
      ...enumsList[0],
    ];
    this.searchBoxData.cardTypeOptions = this.$route.path.includes('gasCard') ? [
      ...enumsList[4],
    ] : [
      ...enumsList[1],
    ];
    this.searchBoxData.oilStationTypeOptions = [
      { label: '全部', value: '' },
      ...enumsList[2],
    ];
    this.onChangeFromType();
  },
};
</script>

<style lang="scss" scoped>
</style>
